import React, {PropsWithChildren} from 'react';
import {IconButton, IconButtonProps, MuiThemeProvider} from '@material-ui/core';
import styled from 'styled-components';
import {AppTheme} from '../../../../styles/app-theme';

const buttonTheme: Partial<AppTheme> = {
    overrides: {
        MuiIconButton: {
            root: {
                backgroundColor: '#edeff0',
                borderRadius: '4px',
                padding: 0,
                '&:hover': {
                    backgroundColor: '#dce0e2'
                }
            }
        }
    }
};

type Props = IconButtonProps

export const CloseButton = (props: Props) => {
    return (
        <MuiThemeProvider theme={buttonTheme}>
            <IconButton aria-label={'close'} {...props}>
                <CloseIcon/>
            </IconButton>
        </MuiThemeProvider>
    );
};

export const CloseButtonRightSide = styled(CloseButton)`
  position: absolute;
  right: 20px;
  top: 20px;
`;

export const CloseIcon = (props: PropsWithChildren<any>) => {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24" {...props}>
            <g>
                <path
                    d="M8,8 L16,16 M16,8 L8,16"
                    id="cross-shape"
                    stroke="#3b4e5e"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                </path>
            </g>
        </svg>
    );
};
